/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：270
 */

module.exports = {
  widgetMallDialog: "WidgetMallDialog_widgetMallDialog__1URzI",
  widgetLabel: "WidgetMallDialog_widgetLabel__1fptD",
  active: "WidgetMallDialog_active__2jgZK",
  DialogFooter: "WidgetMallDialog_DialogFooter__2dTWC",
  cardContainer: "WidgetMallDialog_cardContainer__5WIn4",
  widgetCard: "WidgetMallDialog_widgetCard__2zbnR",
  invisibleWidget: "WidgetMallDialog_invisibleWidget__R3MUc",
  visibleWidget: "WidgetMallDialog_visibleWidget__1PvX3",
  widgetCardFooter: "WidgetMallDialog_widgetCardFooter__1GiB8",
  invisibleWidgetHeader: "WidgetMallDialog_invisibleWidgetHeader__29lGQ",
  widgetIcon: "WidgetMallDialog_widgetIcon__1cf9Z",
  widgetIntroContainer: "WidgetMallDialog_widgetIntroContainer__2oSQv",
  widgetIntro: "WidgetMallDialog_widgetIntro__3OHZ6",
  widgetImgContainer: "WidgetMallDialog_widgetImgContainer__3LSFB",
  icon: "WidgetMallDialog_icon__3dYPY",
  addIcon: "WidgetMallDialog_addIcon__39a1J",
  selectedIcon: "WidgetMallDialog_selectedIcon__1WQ3c",
  added: "WidgetMallDialog_added__3xx9Q",
  widgetInfo: "WidgetMallDialog_widgetInfo__2ll_b",
  widgetName: "WidgetMallDialog_widgetName__2HkXL",
  authorName: "WidgetMallDialog_authorName__27JoW",
  selectedWidgetCard: "WidgetMallDialog_selectedWidgetCard__3j4WZ",
  networkError: "WidgetMallDialog_networkError__23eGw"
}
